// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminLeadsPageContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  min-height: 100vh;
  margin-top: 1vh;
}

.adminLeadsPageHeader {
  color: #ffffff;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}

.leadDetails-noLead {
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  margin-top: 1rem;
  padding: 8px;
  color: #247a97;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.adminLeadsTableWrapper {
  margin-top: 1rem;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow-x: auto;
  padding: 8px;
}

.adminLeadsTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: left;
}

.adminLeadsTable thead {
  background-color: #e2e2e2;
}

.adminLeadsTable th {
  color: #247a97;
  font-size: 1rem;
  justify-content: center;
  word-wrap: break-word;
}

.adminLeadsTable tr {
  border: 1px solid #ccc;
}

.singleLeadLine {
  word-wrap: break-word;
  margin-bottom: 1rem;

  &:hover {
    background-color: #f0f0f0;
  }
}

.adminLeadsTableHeader th {
  background-color: #e2e2e2;
  color: #247a97;
  font-size: 1.5rem;
  padding: 8px;
}

.adminLeadsTableRow:hover {
  background-color: #e5e7eb;
}

.adminLeadsTableCell {
  padding: 8px;
  font-size: 1.25rem;
  vertical-align: middle;
  text-align: left;
  word-wrap: break-word;
}

.adminLeadsActionButton {
  padding: 8px 16px;
  background-color: #247a97;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.adminLeadsActionButton:hover {
  background-color: #22c55e;
}

.adminLeadsPagination {
  display: flex;
  justify-content: center;
  padding-top: 16px;
}

.adminLeadsPaginationItem {
  padding: 8px;
  font-size: 1rem;
  margin: 0 4px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid #cccccc;
}

.adminLeadsPaginationItem:hover {
  background-color: #e2e2e2;
}

.edit-form {
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
}

.edit-form input,
.edit-form select,
.edit-form textarea {
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  border: 1px solid #cccccc;
}

.edit-form button {
  padding: 8px 16px;
  background-color: #247a97;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: block;
  margin-top: 8px;
  width: 100%;
}

.edit-form button:hover {
  background-color: #22c55e;
}

.adminLeadDetailsSection {
  margin-top: 1rem;
}

.leadDetails-container {
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.leadDetailsHeading {
  font-size: 1.75rem;
  font-weight: bold;
  color: #247a97;
  text-align: center;
}

.leadDetailsCard {
  margin-top: 16px;
}

.leadDetail {
  font-size: 1.25rem;
  margin-bottom: 8px;
}

@media (max-width: 991px) {
  .adminLeadsPageContainer .adminLeadsTable th {
    font-size: 1.2rem;
  }

  .adminLeadsPageContainer .adminLeadsTable td {
    font-size: 1.2rem;
  }

  .singleLeadLine {
    border: 1px solid #ccc;

    &:hover {
      background-color: #e2e2e2;
      transition: ease 0.3s;
      transform: scale(0.95);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminLeadsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;;EAEnB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;;IAEtB;MACE,yBAAyB;MACzB,qBAAqB;MACrB,sBAAsB;IACxB;EACF;AACF","sourcesContent":[".adminLeadsPageContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: top;\n  width: 100%;\n  min-height: 100vh;\n  margin-top: 1vh;\n}\n\n.adminLeadsPageHeader {\n  color: #ffffff;\n  font-size: 1.75rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.leadDetails-noLead {\n  font-size: 1.75rem;\n  font-weight: bold;\n  text-align: center;\n  margin-top: 1rem;\n  padding: 8px;\n  color: #247a97;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.adminLeadsTableWrapper {\n  margin-top: 1rem;\n  background-color: #ffffff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow-x: auto;\n  padding: 8px;\n}\n\n.adminLeadsTable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  text-align: left;\n}\n\n.adminLeadsTable thead {\n  background-color: #e2e2e2;\n}\n\n.adminLeadsTable th {\n  color: #247a97;\n  font-size: 1rem;\n  justify-content: center;\n  word-wrap: break-word;\n}\n\n.adminLeadsTable tr {\n  border: 1px solid #ccc;\n}\n\n.singleLeadLine {\n  word-wrap: break-word;\n  margin-bottom: 1rem;\n\n  &:hover {\n    background-color: #f0f0f0;\n  }\n}\n\n.adminLeadsTableHeader th {\n  background-color: #e2e2e2;\n  color: #247a97;\n  font-size: 1.5rem;\n  padding: 8px;\n}\n\n.adminLeadsTableRow:hover {\n  background-color: #e5e7eb;\n}\n\n.adminLeadsTableCell {\n  padding: 8px;\n  font-size: 1.25rem;\n  vertical-align: middle;\n  text-align: left;\n  word-wrap: break-word;\n}\n\n.adminLeadsActionButton {\n  padding: 8px 16px;\n  background-color: #247a97;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.adminLeadsActionButton:hover {\n  background-color: #22c55e;\n}\n\n.adminLeadsPagination {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.adminLeadsPaginationItem {\n  padding: 8px;\n  font-size: 1rem;\n  margin: 0 4px;\n  border-radius: 4px;\n  background-color: white;\n  border: 1px solid #cccccc;\n}\n\n.adminLeadsPaginationItem:hover {\n  background-color: #e2e2e2;\n}\n\n.edit-form {\n  padding: 16px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-top: 16px;\n}\n\n.edit-form input,\n.edit-form select,\n.edit-form textarea {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 8px;\n  border-radius: 4px;\n  border: 1px solid #cccccc;\n}\n\n.edit-form button {\n  padding: 8px 16px;\n  background-color: #247a97;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  display: block;\n  margin-top: 8px;\n  width: 100%;\n}\n\n.edit-form button:hover {\n  background-color: #22c55e;\n}\n\n.adminLeadDetailsSection {\n  margin-top: 1rem;\n}\n\n.leadDetails-container {\n  padding: 16px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.leadDetailsHeading {\n  font-size: 1.75rem;\n  font-weight: bold;\n  color: #247a97;\n  text-align: center;\n}\n\n.leadDetailsCard {\n  margin-top: 16px;\n}\n\n.leadDetail {\n  font-size: 1.25rem;\n  margin-bottom: 8px;\n}\n\n@media (max-width: 991px) {\n  .adminLeadsPageContainer .adminLeadsTable th {\n    font-size: 1.2rem;\n  }\n\n  .adminLeadsPageContainer .adminLeadsTable td {\n    font-size: 1.2rem;\n  }\n\n  .singleLeadLine {\n    border: 1px solid #ccc;\n\n    &:hover {\n      background-color: #e2e2e2;\n      transition: ease 0.3s;\n      transform: scale(0.95);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
